/* eslint-disable */
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import Image from "next/image";
import css from "./.module.scss";
import config from "../../../common/config";
import { CloudfrontImageLoader, ImagesLoader } from "../../../lib/helpers";
import { Modal } from "@aqar-app/react-ui";
import { useRouter } from "next/router";
import { Icon } from "@/components/icon";
import { usePath } from "@/contexts/path/path";
import { trackGenericCTAClickEvent } from "@/lib/tracking/trackNavigationEvents";
import Skeleton from "@/components/skeleton";
import { useDeviceViewPort } from "@/hooks/viewport";

export function ListingImagesHolder() {
  return (
    <>
      <Skeleton className={css.wrapper}>
        <Skeleton.Item className={css.listingImagesHolder} />
      </Skeleton>

      <Skeleton>
        <Skeleton.Item style={{ width: "100%", height: "2.5rem" }} />
      </Skeleton>
      <Skeleton>
        <Skeleton.Item style={{ width: "100%", height: "25rem" }} />
      </Skeleton>

      <Skeleton>
        <Skeleton.Item style={{ width: "15rem", height: "1.5rem" }} />
      </Skeleton>
    </>
  );
}
const CountMapCSS = {
  1: css.one,
  2: css.two,
  3: css.three,
  4: css.four,
};
export const MobileSwiper = ({ images: im, alt }) => {
  const images = useMemo(() => {
    return im.slice(0).reverse();
  }, [im]);
  const ref = useRef();
  const width = typeof window === "undefined" ? 0 : window.innerWidth;

  const [ready, setReady] = useState(false);
  useEffect(() => {
    //number of slides
    const n = images.length;
    let i = n - 1,
      x0 = null,
      locked = false,
      w;
    ref.current?.parentElement?.style.setProperty("--slide", `"1/${n}"`);
    ref.current?.style.setProperty("--i", i);
    ref.current?.style.setProperty("--n", n);

    function unify(e) {
      return e.changedTouches ? e.changedTouches[0] : e;
    }

    function lock(e) {
      x0 = unify(e).clientX;
      ref.current?.classList.toggle(css.smooth, !(locked = true));
    }

    function drag(e) {
      e.preventDefault();

      if (locked)
        ref.current?.style.setProperty(
          "--tx",
          `${Math.round(unify(e).clientX - x0)}px`,
        );
    }

    function move(e) {
      if (locked) {
        let dx = unify(e).clientX - x0,
          s = Math.sign(dx),
          f = +((s * dx) / w).toFixed(2);

        if ((i > 0 || s < 0) && (i < n - 1 || s > 0) && f > 0.2) {
          ref.current?.style.setProperty("--i", (i -= s));
          f = 1 - f;
          ref.current?.parentElement?.style.setProperty(
            "--slide",
            `"${n - i}/${n}"`,
          );
        }
        ref.current?.style.setProperty("--tx", "0px");
        ref.current?.style.setProperty("--f", f);
        ref.current?.classList.toggle(css.smooth, !(locked = false));
        x0 = null;
      }
    }

    function size() {
      w = window.innerWidth;
    }

    size();

    addEventListener("resize", size, false);

    ref.current?.addEventListener("mousedown", lock, false);
    ref.current?.addEventListener("touchstart", lock, false);

    ref.current?.addEventListener("mousemove", drag, false);
    ref.current?.addEventListener("touchmove", drag, false);

    ref.current?.addEventListener("mouseup", move, false);
    ref.current?.addEventListener("touchend", move, false);
    setReady(true);

    return () => {
      removeEventListener("resize", size, false);

      ref.current?.removeEventListener("mousedown", lock, false);
      ref.current?.removeEventListener("touchstart", lock, false);

      ref.current?.removeEventListener("mousemove", drag, false);
      ref.current?.removeEventListener("touchmove", drag, false);

      ref.current?.removeEventListener("mouseup", move, false);
      ref.current?.removeEventListener("touchend", move, false);
    };
  }, [images]);
  return (
    <div className={css.swiperContianer}>
      <div ref={ref} className={`${css.swiper} ${ready ? css.ready : ""}`}>
        {ready ? (
          images.map((image, i) => (
            <div key={image + i} className={css.slide}>
              <Image
                alt={`${alt} صورة ${i + 1}`}
                unoptimized
                fill
                src={`${config.IMAGES_BASE_URL}webp/750x0/props/${image}`}
                priority={i === images.length - 1}
                style={{
                  objectFit: "cover",
                }}
              />
            </div>
          ))
        ) : (
          <div key={im[0]} className={css.fixed}>
            <Image
              alt={`${alt} صورة 1`}
              unoptimized
              style={{
                objectFit: "cover",
              }}
              fill
              src={`${config.IMAGES_BASE_URL}webp/750x0/props/${im[0]}`}
              priority
            />
          </div>
        )}
      </div>
    </div>
  );
};

function ModalContent({ listing, propertyCategory, listingType }) {
  const path = usePath();
  const lastIdRef = useRef(0);
  const { title: alt, imgs } = listing;

  useEffect(() => {
    if (path.resolving || lastIdRef.current === listing?.id) return;
    lastIdRef.current = listing.id;
    trackGenericCTAClickEvent("view_media", {
      listing_type: path.category?.ga_listing_type || listingType,
      property_category:
        path.category?.ga_property_category || propertyCategory,
    });
  }, [path]);
  return (
    <Modal.ClassicOverlay>
      <div dir="rtl" className={css.modal}>
        <div className={css.header}>
          <p>الصور ({imgs.length})</p>
          <Modal.CloseButton />
        </div>
        {imgs.map((image, i) => (
          <div key={image} className={css.image}>
            <Image
              src={image || ""}
              loader={ImagesLoader({
                100: "80",
                120: "120",
                180: "120",
                250: "120",
                300: "120",
                350: "180",
                640: "180",
                750: "350",
                828: "350",
                1080: "750",
                1200: "750",
                1920: "750",
                2048: "750",
                3840: "750",
              })}
              alt={`${alt} صورة ${i + 1}`}
              width={0}
              height={0}
              sizes="100vw"
              placeholder={"blur"}
              blurDataURL={`${config.IMAGES_BASE_URL}webp/5x5/props/${image}`}
            />
          </div>
        ))}
      </div>
    </Modal.ClassicOverlay>
  );
}

function ListingImages({ listing, loaded, propertyCategory, listingType }) {
  const { title: alt, imgs } = listing;
  const [main = "villa-default.png", ...images] = imgs?.slice(0, 5) || [];
  const router = useRouter();
  const modalOpened = useRef(false);
  const [isMobile] = useDeviceViewPort();

  const openModal = useCallback(() => {
    Modal.open(
      <ModalContent
        listing={listing}
        propertyCategory={propertyCategory}
        listingType={listingType}
      />,
      {
        onClose: () => {
          if (location.hash === "#images") history.back();
        },
      },
    )();
  }, [listing]);
  useEffect(() => {
    const hash = location.hash;
    if (!modalOpened.current) {
      modalOpened.current = true;
      if (hash === "#images") {
        setTimeout(openModal, 100);
      }
    }

    const onhashchange = (event) => {
      const hash = location.hash;

      if (hash === "#images") {
        openModal();
        modalOpened.current = false;
      } else Modal.close();
    };

    window.addEventListener("hashchange", onhashchange);

    return () => window.removeEventListener("hashchange", onhashchange);
  }, [openModal, router]);

  return (
    <div
      onClick={(e) => {
        history.pushState({ openModal: true }, "", "#images");
        openModal();
      }}
      className={css.wrapper}
    >
      {isMobile ? (
        <MobileSwiper images={imgs} alt={alt} />
      ) : (
        <div className={css.listingImages}>
          <div
            key={main}
            className={`${css.main} ${CountMapCSS[imgs?.length || 0]}`}
          >
            <Image
              src={main}
              alt={`${alt} 1 صورة`}
              fill
              loader={ImagesLoader({
                100: "80",
                120: "120",
                180: "120",
                250: "120",
                300: "120",
                350: "180",
                640: "180",
                750: "1080",
                828: "1080",
                1080: "1080",
                1200: "1080",
                1920: "1080",
                2048: "1080",
                3840: "1080",
              })}
              style={{
                objectFit: "cover",
              }}
              sizes="(max-width: 640px) 60vw, 100vw"
              placeholder={loaded ? "empty" : "blur"}
              blurDataURL={
                loaded
                  ? loaded
                  : `${config.IMAGES_BASE_URL}webp/5x5/props/${main}`
              }
              priority
            />
          </div>
          <div className={`${css.secondary} ${CountMapCSS[imgs?.length || 0]}`}>
            {images.map((image, i) => (
              <div
                className={`${css.image}  ${CountMapCSS[images?.length || 0]}`}
                key={image + i}
              >
                <Image
                  src={image || ""}
                  loader={CloudfrontImageLoader}
                  sizes="(max-width: 600px) 40vw, 100vw"
                  alt={`${alt} صورة ${i + 2}`}
                  fill
                  style={{
                    objectFit: "cover",
                  }}
                  placeholder={"blur"}
                  blurDataURL={`${config.IMAGES_BASE_URL}webp/5x5/props/${image}`}
                  priority
                />
              </div>
            ))}
          </div>
        </div>
      )}
      {imgs?.length ? (
        <button className={css.more}>
          <Icon width={15} height={15} name="Items" />
          الصور ({imgs.length})
        </button>
      ) : null}
    </div>
  );
}

export default ListingImages;
